var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVpaEnable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 22,
    viewBox: "0 0 15 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.65626 0L15.0004 10.5877L3.75977 21.1817L5.09587 16.3773L11.2428 10.5877L8.32016 4.79805L9.65626 0Z",
    fill: "#0E8635"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.90296 0L11.2471 10.5877L0 21.1817L5.90296 0Z",
    fill: "#E97208"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVpaEnable);
export default __webpack_public_path__ + "static/media/vpa-enable.08c0607d47b502b52712367dc25d849e.svg";
export { ForwardRef as ReactComponent };